export default "__VITE_ASSET__085c7fc9__"